/** @jsxImportSource @emotion/react */
import plus from '../assets/icons/plus.svg';
import minus from '../assets/icons/minus.svg';
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { CLICKABLE, UNSELECTABLE_TEXT } from '../styles/styles';
import { BLUE_CREEK, COOL_GREY } from '../styles/colors';
import ClamShell from './ClamShell';
import { assoc } from '../language/module';

const collapsibleClickCss = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 20px;
  ${CLICKABLE};
`;

const collapsibleImage = css`
  width: 40px;
  height: 40px;
  flex-basis: 40px;
  flex-shrink: 0;
  flex-grow: 0;
  margin-top: 15px;
  display: inline-block;
  transition: all .5s ease;
  cursor: pointer;
  ${UNSELECTABLE_TEXT};
`;

/**
 * Collapsible Group
 * A grouping component that renders children under a header that can be clicked to expand/collapse.
 *
 * PureComponent: true
 * Connected to redux: false
 */
export default class CollapsibleGroup extends React.PureComponent<{
  header: string;
  startCollapsed?: boolean;
  rootCss?: SerializedStyles;
  onClick?: () => void;
  children?: React.ReactNode;
}, {
  isCollapsed: boolean;
}> {
  public state = {
    isCollapsed: !!this.props.startCollapsed,
  };

  private onCollapseClick = () => this.setState(prev => assoc('isCollapsed', !prev.isCollapsed, prev));

  public render() {
    return (
      <div css={css`
             border-top: 1px solid ${COOL_GREY};
             ${this.props.rootCss};
           `}>
        <div onClick={this.onCollapseClick}
             css={collapsibleClickCss}>
          <h2 title={this.props.header}
              css={css`font-size: 25px; color: ${BLUE_CREEK};`}>{this.props.header}</h2>
          <img src={this.state.isCollapsed ? plus : minus}
               alt={this.state.isCollapsed ? '+' : '-'}
               css={collapsibleImage}/>
        </div>
        <ClamShell isOpen={!this.state.isCollapsed}
                   springConfig={{ stiffness: 300, damping: 40, precision: .1 }}>
          {this.props.children}
        </ClamShell>
      </div>
    );
  }
}
